import { render, staticRenderFns } from "./WebhooksForm.vue?vue&type=template&id=0562a02e"
import script from "./WebhooksForm.vue?vue&type=script&lang=js"
export * from "./WebhooksForm.vue?vue&type=script&lang=js"
import style0 from "./WebhooksForm.vue?vue&type=style&index=0&id=0562a02e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports